import { Suspense } from 'react';
import { Provider } from 'react-redux';
import store from 'store';
import App from 'app';
import { getAppRoot } from 'utility/app';
import 'i18n-config'; // initialize translations
import ToastProvider from 'components/ToastProvider';
import { QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { unsafeRootQueryClient } from 'queries/unsafe-query-client';
import Loader from 'components/Kizen/Loader';
import structuredClone from 'core-js-pure/actual/structured-clone';
import { createRoot } from 'react-dom/client';
import { Blocker } from './Blocker';
import { PluginContextWrapper } from 'ts-components/Plugins/PluginContext';
import { Router } from 'react-router-dom';
import { history } from 'routes';
import { AppInsetStyles } from 'ts-components/AppInset/AppInsetStyles';
import { KiCodeStateProvider } from 'ts-components/KiCode/KiCodeStateProvider';
import { KiCodeHost } from 'ts-components/KiCode/KiCodeHost';

if (!('structuredClone' in window)) {
  window.structuredClone = structuredClone;
}

const container = getAppRoot();
const root = createRoot(container);

root.render(
  <QueryClientProvider client={unsafeRootQueryClient}>
    {/* Don't worry, this results in a No-Op component in production automagically */}
    <ReactQueryDevtools initialIsOpen={false} />
    <AppInsetStyles />
    <Provider store={store}>
      <Blocker />
      <ToastProvider>
        <Router history={history}>
          <KiCodeStateProvider>
            <PluginContextWrapper>
              <KiCodeHost />
              <Suspense fallback={<Loader loading />}>
                <App />
              </Suspense>
            </PluginContextWrapper>
          </KiCodeStateProvider>
        </Router>
      </ToastProvider>
    </Provider>
  </QueryClientProvider>
);
